import { render, staticRenderFns } from "./ServicePartnerForm.vue?vue&type=template&id=21d4e7d7"
import script from "./ServicePartnerForm.vue?vue&type=script&lang=js"
export * from "./ServicePartnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports